import { hooks, models } from "@vote4dance/judging-sdk";
var SessionState = hooks.sessions.SessionState;
var useSession = hooks.sessions.useSession;
var Stream = hooks.streams.Stream;
var OrganizationItemSource = models.organizations.OrganizationItemSource;
import { OrganizationPermissions } from "@vote4dance/judging-schema";
export function useOrganization(organization_id) {
    const [organization, loading, error] = Stream(organization_id ? OrganizationItemSource(organization_id) : undefined);
    const sessionState = useSession();
    const isMember = organization ? organization.organization_approved > 0 : false;
    const isSystemAdministrator = SessionState.isSystemAdministrator(sessionState);
    const isCoach = organization ? isSystemAdministrator || [OrganizationPermissions.Coach, OrganizationPermissions.Manager, OrganizationPermissions.Administrator].includes(organization.organization_permissions) : false;
    const isManager = organization ? isSystemAdministrator || [OrganizationPermissions.Manager, OrganizationPermissions.Administrator].includes(organization.organization_permissions) : false;
    const isAdministrator = organization ? isSystemAdministrator || [OrganizationPermissions.Administrator].includes(organization.organization_permissions) : false;
    const showAdmin = organization ? isSystemAdministrator || [OrganizationPermissions.Coach, OrganizationPermissions.Manager, OrganizationPermissions.Administrator].includes(organization.organization_permissions) : false;
    return {
        organization,
        loading,
        error,
        isMember,
        isCoach,
        isManager,
        isAdministrator,
        showAdmin
    };
}
